import React, { Component } from "react"
import PropTypes from "prop-types"

// Connects to ScreensizeProvider and passes screensize prop to composed component.

export default function withScreensize(ComposedComponent) {
  return class extends Component {
    static contextTypes = {
      screensize: PropTypes.string.isRequired,
    }

    render() {
      return (
        <ComposedComponent
          screensize={this.context.screensize}
          {...this.props}
        />
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/withScreensize.js